//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, useTheme } from '@mui/material'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { TopAppBar } from '@react/topbar/TopAppBar'

import WidthLimited from '@react/components/WidthLimited'
import { logOT } from '@shared/loggingShared'
import SystemSettingsManagement from './SystemSettingsManagement'

export default function OperatorRouting(): React.ReactElement {
  const theme = useTheme()
  logOT.debug('AdminRouting')

  return (
    <Box
      data-testid="OperatorRoutingBox1"
      sx={{ height: '100%', width: '100%', backgroundColor: theme.palette.background.canvas }}
    >
      <TopAppBar></TopAppBar>

      <Routes>
        <Route
          path="/"
          element={
            <WidthLimited>
              <SystemSettingsManagement />
            </WidthLimited>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  )
}
